<template>
  <header :class="['glass-topbar', 'glass-topbar--wordmark', { 'is-open': isOpen, 'is-scrolled': isScrolled }]">
    <router-link class="glass-topbar__brand glass-topbar__brand--main" :to="{ name: 'home' }" @click="closeMenu">
      <img class="glass-topbar__brand-logo" src="/static/LOGOFOMO26_pro.png" alt="Fomo Planes" />
    </router-link>

    <button class="glass-topbar__menu-button" type="button" @click="toggleMenu">
      <i class="fas" :class="isOpen ? 'fa-times' : 'fa-bars'"></i>
    </button>

    <div class="glass-topbar__nav">
      <nav class="glass-topbar__links" :style="toolbarStyle">
        <div class="glass-topbar__toolbar">
          <div class="glass-topbar__indicator">
            <div class="glass-topbar__indicator-glow"></div>
            <div class="glass-topbar__indicator-clip">
              <div class="glass-topbar__indicator-ring"></div>
            </div>
            <div class="glass-topbar__indicator-plate"></div>
          </div>
        </div>

        <div v-for="item in navItems" :key="item.name" class="glass-topbar__link-wrap">
          <router-link :class="linkClass(item.name)" :to="item.to" @click="closeMenu">
            <i :class="['glass-topbar__link-icon', item.icon]"></i>
            <span class="glass-topbar__link-label">{{ item.label }}</span>
          </router-link>
        </div>
      </nav>

      <button class="glass-topbar__cta" type="button" @click="openLaunchPage">
        <i class="fas fa-calendar-alt"></i>
        Lanza tu evento
      </button>

      <div class="glass-topbar__search">
        <div class="glass-search">
          <input
            v-model="userInput"
            type="text"
            placeholder="Busca la proxima noche que quieres comprar"
            @input="change"
          />
          <span class="glass-search__icon">
            <i class="fas fa-search"></i>
          </span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { apiService } from '../common/api.services.js'

export default {
  name: 'HeaderMain',

  props: {
    hideWallet: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    navItems() {
      const items = [
        { name: 'home', label: 'Eventos', icon: 'fas fa-compass', to: { name: 'home' } },
        { name: 'usertickets', label: 'Entradas', icon: 'fas fa-ticket-alt', to: { name: 'usertickets' } },
        { name: 'wallet', label: 'Wallet', icon: 'fas fa-wallet', to: { name: 'wallet' } },
      ]
      return this.hideWallet ? items.filter((item) => item.name !== 'wallet') : items
    },

    activeIndex() {
      const routeName = this.$route.name === 'account' ? 'wallet' : this.$route.name
      const index = this.navItems.findIndex((item) => item.name === routeName)
      return index >= 0 ? index : 0
    },

    toolbarStyle() {
      return {
        '--count': this.navItems.length,
        '--active-index': this.activeIndex,
      }
    },
  },

  data() {
    return {
      isOpen: false,
      isScrolled: false,
      userInput: '',
    }
  },

  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll() {
      this.isScrolled = (window.scrollY || window.pageYOffset || 0) > 18
    },

    async change() {
      const term = this.userInput.trim()

      if (!term) {
        this.$emit('messageFromHeader', [], '')
        return
      }

      const endpoint = `/api/events/?search=${encodeURIComponent(term)}`
      const data = await apiService(endpoint)
      const results = data && data.results ? data.results : []
      this.$emit('messageFromHeader', results, term)
    },

    openLaunchPage() {
      this.$router.push({ name: 'launch-event' })
    },

    toggleMenu() {
      this.isOpen = !this.isOpen
    },

    closeMenu() {
      this.isOpen = false
    },

    linkClass(routeName) {
      const index = this.navItems.findIndex((item) => item.name === routeName)
      return ['glass-topbar__link', { 'is-active': index === this.activeIndex }]
    },
  },

  watch: {
    $route() {
      this.closeMenu()
    },
  },
}
</script>

<style scoped>
.glass-topbar--wordmark::before {
  content: none !important;
  display: none !important;
}

.glass-topbar--wordmark.is-scrolled::before {
  content: none !important;
  display: none !important;
}

.glass-topbar__brand--main {
  gap: 0;
  flex-shrink: 0;
  justify-self: start;
  max-width: 236px;
}

.glass-topbar__brand-logo {
  display: block;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 10px 24px rgba(142, 111, 198, 0.22));
}

@media (max-width: 1100px) {
  .glass-topbar__brand--main {
    max-width: 204px;
  }
}

@media (max-width: 720px) {
  .glass-topbar__brand--main {
    max-width: 168px;
  }
}
</style>
